import { Alert, Box, Checkbox, Divider, FormControl, FormControlLabel, Grid, Typography } from "@mui/material";
import dayjs from "dayjs";
import React from "react";
import { examineeServiceTypeIds, REFERRAL_STATUS_DISPLAYS } from "../../constants/referralConstants";
import useUser from "../../hooks/useUser";
import { Link as RouterLink } from "react-router-dom";
import InjuredEmployeeDetails from "./InjuredEmployeeDetails";
import WorkplaceDetails from "./WorkplaceDetails";
import ComcareClaimDetails from "./ComcareClaimDetails";
import RehabAssessmentDetails from "./RehabAssessmentDetails";
import ManagerDetails from "./ManagerDetails";
import TreatingDoctorDetails from "./TreatingDoctorDetails";
import RCMDetails from "./RCMDetails";

const CompensationDetails = ({ referral }) => {
    const { userTypeNavLinks } = useUser();
    const dashboardLink = userTypeNavLinks.filter((link) => link.key === 'dashboard')[0];
    const dashboardUrl = dashboardLink ? dashboardLink.url : undefined;
    const { detail, serviceTypeId } = referral;
    const { anonymisedReferral } = detail || {};

    return (
        <Box
            sx={{
                margin: 2,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'left',
            }}
        >
            <Grid container spacing={1} sx={{ mb: 2 }}>
                <Grid item xs={12} sm={3}>
                    <Typography component="p" variant="body">Referral ID</Typography>
                </Grid>
                <Grid item xs={12} sm={9}>
                    <Typography component="p" variant="body2">{referral.id}</Typography>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <Typography component="p" variant="body">Date created</Typography>
                </Grid>
                <Grid item xs={12} sm={9}>
                    <Typography component="p" variant="body2">{dayjs(referral.created).format('DD MMM YYYY')}</Typography>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <Typography component="p" variant="body">Status</Typography>
                </Grid>
                <Grid item xs={12} sm={9}>
                    <Typography component="p" variant="body2">{REFERRAL_STATUS_DISPLAYS[referral.status]}</Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <Typography><RouterLink to={dashboardUrl}>Back to dashboard</RouterLink></Typography>
                </Grid>
            </Grid>
            <Divider />
            <RCMDetails referral={referral} />
            <Divider />
            {!anonymisedReferral &&
                <React.Fragment>
                    <InjuredEmployeeDetails referral={referral} />
                    <Divider />
                    <WorkplaceDetails referral={referral} />
                    <Divider />
                    {(!serviceTypeId || !examineeServiceTypeIds.includes(serviceTypeId)) &&
                        <React.Fragment>
                            <ManagerDetails referral={referral}/>
                            <Divider />
                            <TreatingDoctorDetails referral={referral}/>
                            <Divider />
                        </React.Fragment>
                    }
                </React.Fragment>
            }
            {anonymisedReferral &&
                <React.Fragment>
                    <Typography variant="h3" sx={{ mt: 2 }}>Anonymised Referral</Typography>
                    <FormControl component="fieldset"  sx={{ mt: 2, mb: 2, width: '75ch' }}>
                        <FormControlLabel
                            control={<Checkbox disabled checked={anonymisedReferral} size="small"/>}
                            label="Has acknowledged that this is an anonymised referral. This form must not contain any personal information relating to the employee. Please ensure that a Personal Particulars Form has been provided."
                        />
                    </FormControl>
                    <Divider />
                </React.Fragment>
            }
            <ComcareClaimDetails referral={referral} />
            <Divider />
            <RehabAssessmentDetails referral={referral} />
            <Divider />
            <Alert severity="info" sx={{ mt: 2 }}>
                <Typography variant="h3">
                    Notes for Rehabilitation Case Managers (RCM)
                </Typography>
                <Typography component="div" variant="body2">
                    <ul>
                        <li>
                            Please forward the Medical Release Authority form and Existing Medical Information to the engaged Provider.
                        </li>
                    </ul>
                </Typography>
            </Alert>
        </Box>
    );
}

export default CompensationDetails;
